import { Component, Inject, Input, OnInit } from '@angular/core';
import {
  UserService,
  UserSettingsOutputModel,
} from '@cloudia-shared/apis/generated/user-api';
import { ModalController } from '@ionic/angular';
import { BaseComponent } from '@tcp/cloudia-utilities';
import { take } from 'rxjs';
import { FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'cloudia-cookie-settings',
  templateUrl: './cookie-settings.component.html',
  styleUrls: ['./cookie-settings.component.scss'],
})
export class CookieSettingsComponent extends BaseComponent implements OnInit {
  modal: any;
  tenant: string;
  userSettings: UserSettingsOutputModel;
  @Input() isModal?: boolean;
  cookiesStatusControl = new FormControl(false);

  constructor(
    private readonly modalController: ModalController,
    private readonly toastrService: ToastrService,
    @Inject(UserService) private readonly userApi: UserService
  ) {
    super();
  }

  ngOnInit(): void {
    this.tenant = this.tenantService.getTenant();
    this.loadUserSettings();
    this.cookiesStatusControl.valueChanges.subscribe(() => {
      this.userSettings = {
        dateAndTimeSettings: this.userSettings.dateAndTimeSettings,
        cookiePreferences: {
          necessaryCookies: {
            accepted: true,
          },
          analyticalCookies: {
            accepted: this.cookiesStatusControl.value,
          },
        },
      };

      if (!this.isModal) {
        this.updateUserSettings();
      }
    });
  }

  private loadUserSettings(): void {
    this.userApi
      .getUserSettings()
      .pipe(take(1))
      .subscribe((settings: UserSettingsOutputModel) => {
        this.userSettings = settings;
        this.cookiesStatusControl.setValue(
          this.userSettings.cookiePreferences.analyticalCookies.accepted,
          {
            emitEvent: false,
          }
        );
      });
  }

  private updateUserSettings() {
    this.userSettings.cookiePreferences.necessaryCookies.accepted = true;
    this.userApi.updateUserSettings(this.userSettings).subscribe({
      next: () => {
        if (!this.isModal) {
          this.toastrService.success('Cookie preferences updated', 'Cookies', {
            timeOut: 1500,
          });
        }
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      },
      error: (err) => {
        throw new Error(`Settings update error: ${err?.message}`);
      },
    });
  }

  saveChanges(event) {
    this.updateUserSettings();
    if (this.isModal) {
      this.close(event);
    }
  }

  async close(event) {
    event.stopPropagation();
    await this.modalController.dismiss();
  }
}
